export enum PaymentMethodTypeEnum {
    transfer = "transfer",
    cash = "cash",
    card = "card",
    paypal = "paypal",
    other = "other",
}


export class PaymentMethodType {
    constructor(
        public readonly id: PaymentMethodTypeEnum,
        public readonly label: string,
    ) { }
}